import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import { api } from "#/../convex/_generated/api";

export function useDiscModelSearch(query: string) {
	return useQuery({
		...convexQuery(api.discModels.searchDiscModels, { query }),
		enabled: query.trim().length > 0,
	});
}
